var StoreDetail;
(function (StoreDetail) {
    document.addEventListener('ControllerReady', () => {
        const $containerShopDetail = document.querySelector('.container-shop-detail');
        const $shopDetail = $containerShopDetail.querySelector('.locator-shop-detail');
        let getNamirialEndpoint;
        if ($shopDetail) {
            const store = item_shop;
            const $linkIndication = $shopDetail.querySelector('.indications');
            const $hrefIndications = $linkIndication.getAttribute('href');
            let positionCoordLat;
            let positionCoordLong;
            $containerShopDetail.setAttribute('data-spinner', 'mask');
            getCoords()
                .then(position => {
                positionCoordLat = position.coords.latitude;
                positionCoordLong = position.coords.longitude;
                let replaceLink = $hrefIndications.replace('coords', `${positionCoordLat},${positionCoordLong}/`);
                $linkIndication.setAttribute('href', replaceLink);
            })
                .catch(() => {
                let replaceLink = $hrefIndications.replace('coords', `/`);
                $linkIndication.setAttribute('href', replaceLink);
            })
                .finally(() => {
                $containerShopDetail.removeAttribute('data-spinner');
            });
            function checkFavourite() {
                const storeId = store.id;
                const $favouriteBtn = $shopDetail.querySelector('.favourite-icon');
                let isFavourite = false;
                localforage.getItem('favourite_store').then(shops => {
                    shops = shops || [];
                    isFavourite = shops.some(s => s.id === storeId);
                    if (isFavourite) {
                        $favouriteBtn.classList.add('is-favourite');
                    }
                    $favouriteBtn.addEventListener('click', () => {
                        isFavourite = !isFavourite;
                        $favouriteBtn.classList.toggle('is-favourite', isFavourite);
                        updateFavouriteList(store, isFavourite);
                    });
                });
            }
            function updateFavouriteList(shop, toggle) {
                localforage.getItem('favourite_store').then(shops => {
                    shops = shops || [];
                    if (toggle) {
                        shops.push(shop);
                    }
                    else {
                        shops = shops.filter(s => s.id !== shop.id);
                    }
                    localforage.setItem('favourite_store', shops);
                });
            }
            function buildSpid(storeObj) {
                if (storeObj.spid && storeObj.spid.active) {
                    const spidElement = document.querySelector('.spid-information');
                    spidElement.classList.remove('hidden');
                    const $spidBtn = spidElement.querySelector('.spid-button');
                    let serviceTime;
                    let spidMsg;
                    if (storeObj.spid.startDay) {
                        serviceTime = "(Servizio disponibile: " + storeObj.spid.startDay + " - " + storeObj.spid.endDay + " ore " + storeObj.spid.openTime + " - " + storeObj.spid.closeTime + ")";
                        spidElement.querySelector('.spid-orario').innerHTML = "Servizio disponibile: <b>" + storeObj.spid.startDay + " - " + storeObj.spid.endDay + " ore " + storeObj.spid.openTime + " - " + storeObj.spid.closeTime + "</b>";
                        ;
                        spidElement.querySelector('.spid-orario-mobile').innerHTML = "Servizio disponibile: <b>" + storeObj.spid.startDay + " - " + storeObj.spid.endDay + " ore " + storeObj.spid.openTime + " - " + storeObj.spid.closeTime + "</b>";
                        ;
                    }
                    if (storeObj.spid.description) {
                        spidMsg = storeObj.spid.description;
                        spidElement.querySelector('.spid-msg').innerHTML = spidMsg;
                        spidElement.querySelector('.spid-msg-mobile').innerHTML = spidMsg;
                    }
                    $spidBtn.addEventListener('click', evt => {
                        evt.preventDefault();
                        $containerShopDetail.setAttribute('data-spinner', 'mask');
                        let voucherBody = {
                            idConfiguration: storeObj.spid.idConfiguration,
                            lra: storeObj.spid.lra,
                            pdv: storeObj.cooperativa + ' ' + storeObj.name + ' - ' + storeObj.address,
                            serviceTiming: serviceTime,
                            msg: spidMsg
                        };
                        getVoucher(voucherBody);
                    });
                }
            }
            const getVoucher = body => {
                Fetch('/api/getVoucher', {
                    method: 'POST',
                    data: { idConfiguration: body.idConfiguration, lra: body.lra, pdv: body.pdv, serviceTiming: body.serviceTiming, msg: body.msg },
                    token: {
                        enable: true
                    }
                })
                    .then(rawVoucherStoresResponse => {
                    let voucher = JSON.parse(rawVoucherStoresResponse["data"]).voucher;
                    if (voucher) {
                        const $body = document.querySelector('body');
                        const $modal = document.querySelector('.spid-modal');
                        const $btnAccept = $modal.querySelector('.accept');
                        const $btnNoAccept = $modal.querySelector('.no-accept');
                        $modal.classList.remove('d-none');
                        $body.classList.add('scrollLock');
                        $btnAccept.removeEventListener('click', () => { });
                        $btnAccept.addEventListener('click', () => {
                            window.open(getNamirialEndpoint + voucher, 'New Window');
                            $modal.classList.add('d-none');
                            $body.classList.remove('scrollLock');
                        });
                        $btnNoAccept.removeEventListener('click', () => { });
                        $btnNoAccept.addEventListener('click', () => {
                            $modal.classList.add('d-none');
                            $body.classList.remove('scrollLock');
                        });
                    }
                })
                    .catch((err) => {
                    _flog(0, err, {
                        url: '/api/getVoucher',
                    }, {});
                })
                    .finally(() => {
                    $containerShopDetail.removeAttribute('data-spinner');
                });
            };
            function buildPromo(promos) {
                const $root = document.querySelector('.flyer-wrap');
                if (!$root)
                    return;
                const $swiperEl = $root.querySelector('.flyer-swiper');
                const $wrapper = $swiperEl ? $swiperEl.querySelector('.swiper-wrapper') : null;
                if (!$swiperEl || !$wrapper)
                    return;
                const $template = $wrapper.querySelector('.swiper-slide');
                if (!$template)
                    return;
                const templateNode = $template.cloneNode(true);
                if (!promos || promos.length === 0) {
                    $root.classList.add('hidden');
                    return;
                }
                promos.forEach(promo => {
                    if (!promo || !promo.cover || !promo.description) {
                        viewOfferDefault($root, promo);
                        return;
                    }
                    const $slide = templateNode.cloneNode(true);
                    const $thumb = $slide.querySelector('.thumb');
                    const $title = $slide.querySelector('.title');
                    const $dates = $slide.querySelector('.dates');
                    const $cta = $slide.querySelector('.cta');
                    if ($thumb && promo.cover) {
                        $thumb.style.backgroundImage = `url("${promo.cover}")`;
                        $thumb.style.backgroundSize = 'cover';
                        $thumb.style.backgroundPosition = 'center';
                    }
                    if ($title)
                        $title.textContent = promo.description || '';
                    if (promo.url)
                        $slide.setAttribute('href', promo.url);
                    const fmt = (d) => {
                        if (typeof moment !== 'undefined')
                            return moment(d).format('DD/MM/YYYY');
                        const date = new Date(d);
                        const dd = String(date.getDate()).padStart(2, '0');
                        const mm = String(date.getMonth() + 1).padStart(2, '0');
                        const yy = String(date.getFullYear());
                        return `${dd}/${mm}/${yy}`;
                    };
                    if ($dates) {
                        const hasStart = !!promo.startDate;
                        const hasEnd = !!promo.endDate;
                        if (hasStart && hasEnd) {
                            $dates.innerHTML = `Dal ${fmt(promo.startDate)} al ${fmt(promo.endDate)}`;
                        }
                        else if (hasStart) {
                            $dates.textContent = fmt(promo.startDate);
                        }
                        else if (hasEnd) {
                            $dates.textContent = fmt(promo.endDate);
                        }
                        else {
                            $dates.textContent = '';
                        }
                    }
                    $slide.style.display = "block";
                    $wrapper.appendChild($slide);
                });
                $root.classList.remove('hidden');
                trigger(document, 'init-swiper-carousel', $root);
            }
            function viewOfferDefault($scope, promo) {
                const $swiperEl = $scope.querySelector('.flyer-swiper');
                const $wrapper = $swiperEl ? $swiperEl.querySelector('.swiper-wrapper') : null;
                if (!$wrapper)
                    return;
                const $tpl = $scope.querySelector('.is-default-content');
                if (!$tpl)
                    return;
                const $node = $tpl.cloneNode(true);
                $node.style.display = "block";
                if (promo && promo.url) {
                    $node.setAttribute('href', promo.url);
                }
                $wrapper.appendChild($node);
            }
            function retrieveConfig($wrapper) {
                let data;
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        const urlNamirial = $form.querySelector('[name="url-namirial"]').value;
                        const configNamirial = $form.querySelector('[name="config-namirial"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                            urlNamirial: urlNamirial.replace(/\/$/, ''),
                            configNamirial: JSON.parse(configNamirial)
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function getPromos() {
                const config = retrieveConfig($shopDetail);
                getNamirialEndpoint = `${config.urlNamirial}`;
                Fetch('/api/esb/storelocator/getStoreDetail?_format=form', {
                    method: 'POST',
                    data: {
                        storeId: [store.id]
                    },
                    token: {
                        enable: true,
                    }
                }).then(response => {
                    if (response.header.result === 'OK') {
                        buildPromo(response.payload.stores[0].flyers);
                        buildSpid(response.payload.stores[0]);
                    }
                }).catch((err) => {
                    return [];
                });
            }
            checkFavourite();
            getPromos();
        }
    });
})(StoreDetail || (StoreDetail = {}));
